import React from "react";
import { Box, Grid } from "@mui/material";
import { Widgets } from "./Widgets";
import WidgetCard from "./WidgetCard";

const WidgetPanel = () => {
  return (
    <Box
      sx={{
        minHeight: "600px",
        height: "100%",
        backgroundColor: "#f9f9f9",
        padding: "16px",
        width: "fit-content",
        border: "1px solid #ddd",
        borderRadius: "8px",
        overflowY: "auto",
      }}
    >
      <Grid container spacing={0.5}>
        {Widgets.map((widget) => (
          <Grid item xs={6} key={widget.id}>
            <WidgetCard widget={widget} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WidgetPanel;
